import { defineQuery } from 'next-sanity'

export const careersJobListingsBlockFields = `
  _id,
  _type,
  title,
  backgroundColor,
  preSelectedDepartments,
  preSelectedLocations,
  preSelectedJobTypes
`

export const CAREERS_JOB_LISTINGS_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-job-listings-block"][0]{
    ${careersJobListingsBlockFields}
  }
`)
